import Modal from 'components/Modal'
import SpecialIcashRefundTx from 'views/MemberProfile/ManualTx/SpecialIcashRefundTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalSpecialIcashRefund = ({ title, open, onClose }: Props): JSX.Element => (
  <Modal open={open} title={title} onClose={onClose} noFooter>
    <SpecialIcashRefundTx onClose={onClose} />
  </Modal>
)

export default ModalSpecialIcashRefund